import { render, staticRenderFns } from "./PilihTukang.vue?vue&type=template&id=3caec451&scoped=true"
import script from "./PilihTukang.vue?vue&type=script&lang=js"
export * from "./PilihTukang.vue?vue&type=script&lang=js"
import style0 from "./PilihTukang.vue?vue&type=style&index=0&id=3caec451&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caec451",
  null
  
)

export default component.exports